import colors from '@th/shared/src/constants/colors';
import AiSearchIcon from '../../../public/images/icons/ai-search.svg';

type Props = {};

export default function AiSearchIconWithText({}: Props) {
  return (
    <div
      style={{
        height: '2.2em',
        width: '2.2em',
        backgroundColor: colors.lightOrange,
      }}
      className="rounded-full justify-center items-center flex flex-col"
    >
      <div style={{ height: '1em', width: '1em' }}>
        <AiSearchIcon className="text-gold" />
      </div>
      <p className="text-xxs mt-0 mb-0 text-gold">AI</p>
    </div>
  );
}
